import {
  REMOVE_CAMPAIGN,
  LOAD_CAMPAIGNS,
  CREATE_CAMPAIGN,
  UPDATE_CAMPAIGN,
} from 'student-search/actions/campaigns';

const initialState = {};

export const campaignsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CAMPAIGNS: {
      const next = {};
      action.campaigns.forEach((campaign) => {
        if (campaign.id) {
          next[campaign.id] = campaign;
        }
      });
      return next;
    }
    case CREATE_CAMPAIGN: {
      if (!action.campaign?.id) {
        return state;
      }
      return {
        ...state,
        [action.campaign.id]: action.campaign,
      };
    }
    case UPDATE_CAMPAIGN: {
      if (!action.campaign?.id || !state[action.campaign.id]) {
        return state;
      }
      return {
        ...state,
        [action.campaign.id]: action.campaign,
      };
    }
    case REMOVE_CAMPAIGN: {
      const next = {...state};
      delete next[action.campaignId];
      return next;
    }
    default:
      return state;
  }
};
